<template>
  <div class="home">
    <!--Header-->
    <div class="header pb-7 bg-gradient-warning">
      <div class="logo p-4 ">
        <img
          src="../../assets/images/rajput.png"
          width="300"
          height="40"
          alt=""
        />
        <img src="../../assets/images/rajdoot.png" width="300" alt="" />
      </div>
      <div class="container ">
        <div class="header-body">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="title">
                <h2 class="display-4 text-white font-weight-light">
                  All electrical sales and appliance repair services under one
                  roof
                </h2>
                <p class="text-white mt-4">
                  Having more than {{ new Date().getFullYear() - 1994 }} years
                  of experience in the industry we supply all electrical
                  material along with the services
                </p>
                <div class="mt-5">
                  <!-- <router-link to="/dashboard" class="btn btn-neutral my-2"
                    >Explore Services</router-link
                  > -->
                  <a href="/register-request" class="btn btn-neutral my-2">
                    <i class="el-icon-phone"></i>
                    Call Now
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row pt-5">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Appliance Repair</h5>
                      <p>
                        We repair all kinds of home appliances, from geyser to
                        mixer
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-info text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Electricians</h5>
                      <p>
                        We have a team of 20+ electricians
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-lg-5 pt-4">
                  <div class="card mb-4">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-success text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Motor Mechanics</h5>
                      <p>
                        We are famous for Motor rewinding
                      </p>
                    </div>
                  </div>
                  <div class="card mb-4">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Plumbing</h5>
                      <p>We have 10+ in-house members</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-6 pb-9 bg-gray-300">
      <div class="row justify-content-center text-center">
        <div class="col-md-6">
          <h2 class="display-3 text-orange ">A complete digital solution</h2>
          <p class="lead text-orange ">
            Rajput along with Rajdoot Services uses a digital experience
            internally as well as for customers. we operate using an efficient
            online portal. When you register a service request, appropriate
            vendor gets assigned to it based on the type of request, vendor can
            use his android app to connect with you and further update the
            service request through out various stages
          </p>
          <p class="lead text-orange">
            Customers receive update through Whatsapp or SMS
          </p>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-4">
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div
                      class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4"
                    >
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">
                      Raise a service request online
                    </h4>
                    <p class="description mt-3">
                      Its very easy to raise any complain online simply by
                      filling up a form. Also you can visit our branch and raise
                      complain in person.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div
                      class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4"
                    >
                      <i class="el-icon-user"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">
                      Individual as well as Society
                    </h4>
                    <p class="description mt-3">
                      Our customer base is vast. We serve individual and
                      societies including flats, row houses, bunglows, shops.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-5">
                    <div
                      class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4"
                    >
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">
                      Immediate And Expert
                    </h4>
                    <p class="description mt-3">
                      We have team of 30+ expert vendors at your service. We are
                      giving "on site" as well as "in house" service asap.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- available brands section starts -->
    <section class="py-7">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <h1>Available Brands</h1>
        </div>

        <div class="justify-content-center">
          <div class="text-center">
            <nav class="navbar navbar-expand-lg navbar-light ">
              <div class="container p-0">
                <a class="navbar-brand" href="#">
                  <!-- Add brand logo image here -->
                  <img
                    src="../../assets/images/legrand.png"
                    height="50"
                    alt="Brand Logo"
                  />
                </a>
                <a class="navbar-brand" href="#">
                  <!-- Add brand logo image here -->
                  <img
                    src="../../assets/images/havells.png"
                    height="50"
                    alt="Brand Logo"
                  />
                </a>
                <a class="navbar-brand" href="#">
                  <!-- Add brand logo image here -->
                  <img
                    src="../../assets/images/kirloskar.png"
                    height="50"
                    alt="Brand Logo"
                  />
                </a>
                <a class="navbar-brand" href="#">
                  <!-- Add brand logo image here -->
                  <img
                    src="../../assets/images/orient.png"
                    height="50"
                    alt="Brand Logo"
                  />
                </a>
                <a class="navbar-brand" href="#">
                  <!-- Add brand logo image here -->
                  <img
                    src="../../assets/images/anchor.png"
                    height="50"
                    alt="Brand Logo"
                  />
                </a>

                <a class="navbar-brand" href="#">
                  <!-- Add brand logo image here -->
                  <img
                    src="../../assets/images/racold.png"
                    height="50"
                    alt="Brand Logo"
                  />
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <section class="py-5 bg-orange text-white">
      <div class="text-center pt-5">
        <h2 class="text-white display-3">
          Want to raise a service request?
        </h2>
        <div style="width: 70%; padding-left: 30%;">
          <p class="lead text-center px-12">
            Now its easy to raise your service request by just scaning this QR
            code and fill up a form according to your requirement or just click
            on button to open a form.
          </p>
        </div>
      </div>
      <div class="container text-white pt-3">
        <div class="row row-grid align-items-center">
          <div class="col-md-5 text-center">
            <img
              id="barcode"
              src="../../assets/images/rajput-qr.png"
              alt=""
              title="Schan QR"
              width="200"
              height="200"
            />
          </div>
          <div class="col-md-2 text-center lead ni-xl" style="font-weight:500">
            Or
          </div>
          <div class="col-md-5 text-center">
            <div class="btn-wrapper">
              <a
                href="/register-request"
                class="btn btn-white btn-icon mb-3 mb-sm-0"
              >
                <span class="btn-inner--text">Create Service Request</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- customers section starts -->
    <section class="pt-4 bg-gray-300  ">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <h1>Our Happy Customers</h1>
        </div>

        <div class="py-5">
          <VueSlickCarousel
            :arrows="true"
            :dots="true"
            :slidesToShow="4"
            :adaptiveHeight="true"
            :autoplay="true"
            style="height:80px; padding-top: 30px;"
          >
            <div
              class="text-center"
              style="height: 50px;"
              v-for="(item, index) in customers"
              :key="index"
            >
              <span class="areas" style="height:50px">{{ item }}</span>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>
    <!-- customers section ends -->

    <footer class="footer py-3 pt-4">
      <div class="text-white px-6">
        <div class="row">
          <div class="col-md-4">
            <img
              src="../../assets/images/rajput.png"
              width="300"
              style="padding-top: 50px;"
              alt=""
            />
            <img
              src="../../assets/images/rajdoot.png"
              width="300"
              alt=""
              style="padding-top: 50px;"
            />
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-4">
                <h3 class="text-white py-2">Services From Us</h3>
                <li class="mt-4 ">Electrical</li>
                <li class="mt-2">Appliance Repair</li>
                <li class="mt-2">Motor Repairing</li>
                <li class="mt-2">Plubming</li>
              </div>
              <div class="col-md-4">
                <h3 class="text-white py-2">Areas we serve</h3>
                <ul class="list-unstyled">
                  <li><i class="el-icon-location ni-lg mt-3 mr-2" />Aundh</li>
                  <li><i class="el-icon-location ni-lg mt-3 mr-2" /> Baner</li>
                  <li>
                    <i class="el-icon-location ni-lg mt-3 mr-2" /> Balewadi
                  </li>
                  <li><i class="el-icon-location ni-lg mt-3 mr-2" /> Pashan</li>
                </ul>
              </div>
              <div class="col-md-4">
                <h3 class="text-white py-2" style="visibility: hidden;">
                  Areas we serve
                </h3>

                <ul class="list-unstyled">
                  <li>
                    <i class="el-icon-location ni-lg mt-3 ni-lg mr-2" /> Pimple
                    Saudagar
                  </li>
                  <li>
                    <i class="el-icon-location ni-lg mt-3 ni-lg mr-2" />
                    Hinjewadi
                  </li>
                  <li>
                    <i class="el-icon-location ni-lg mt-3 ni-lg mr-2" /> Sangavi
                  </li>
                  <li>
                    <i class="el-icon-location ni-lg mt-3 ni-lg mr-2" /> Wakad
                  </li>
                </ul>
              </div>
            </div>
            <ul class=""></ul>
          </div>

          <div class="col-md-4 text-white">
            <h3 class="text-white py-2">Contact Us</h3>
            <div class="row">
              <div class="col-md-6">
                <h4 class="text-white">Branch Aundh</h4>
                <ul class="list-unstyled">
                  <li>
                    <i class="el-icon-phone ni-lg mr-2" />8237478645 /
                    8237478647
                  </li>
                  <li>
                    <i class="el-icon-location  ni-lg mt-3  mr-2" />
                    <span>
                      Shop No.13,14,15, <br />
                      <span class="ml-4"
                        >"P" Building, Lokasangam <br />
                        <!-- Pune - 07 -->
                      </span>
                      <span class="ml-4">Vihar, Near D.P. Road,</span> <br />
                      <span class="ml-4">Aundh, Pune - 07</span>
                    </span>
                  </li>
                </ul>
              </div>
              <div class="col-md-6">
                <h4 class="text-white">Branch Baner</h4>
                <ul class="list-unstyled">
                  <li>
                    <i class="el-icon-phone ni-lg mr-2" />
                    8237478646
                  </li>
                  <li>
                    <i class="el-icon-location ni-lg mt-3 mr-2" />
                    <span>
                      <span>Shop No.12, Aurelia,</span> <br />
                      <span class="ml-4">Sr. No. 292/4, Pan Card Club</span>
                      <br />
                      <span class="ml-4">Road, Dhankude Vasti, Baner,</span>
                      <span class="ml-4"> Pune 411045</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-white text-center pt-3">
        <p class="text-md">
          © {{ new Date().getFullYear() }} Rajput Electricals. All rights
          reserved.
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
import { Tooltip } from "element-ui";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  data() {
    return {
      customers: [
        "DSK Akashganga, Aundh",
        "Kapil Tranquil Greens, Baner",
        "Platinum Atlantis, Balewadi",
        "Twin Nest, Pashan",
        "Yashodevi Avenue, Pimple Saudagar",
        "Indu Pride, Pimple Nilakh",
        "Avon vista, Hinjewadi",
        "Sai Heritage, Sangavi",
        "Silver Orchards, Wakad"
      ]
    };
  },
  name: "Home",
  components: {
    [Tooltip.name]: Tooltip,
    VueSlickCarousel
  }
};
</script>
<style scoped>
@media (max-width: 1023px) {
  .logo {
    flex-direction: column;
  }
  .title {
    text-align: center;
    padding-top: 20px;
    padding-right: 0px !important;
  }
}
.title {
  padding-right: 3rem;
}
.logo {
  /* padding: 10px; */
  display: flex;
  justify-content: space-between;
  background: #fff;
  align-items: center;
  /* flex-direction: row; */
}
.logo-another {
  display: flex;
  flex-direction: column;
}
.areas {
  font-weight: 600;
}

.bg-orange {
  background-color: #fa8128;
}

.text-orange {
  color: #fa8128;
}

.bg-gray-300 {
  background-color: #dedede;
}
.footer {
  background-color: #3e3e3e;
  opacity: 0.8;
}
.home {
  overflow-x: hidden;
}
</style>
